import React, { useState } from 'react'
import { View, StyleSheet } from 'react-native'
import { Text, Button, Modal, useTheme } from '@ui-kitten/components'
import { useTranslation } from 'react-i18next'
import * as Sentry from "@sentry/react-native"

export default function DeleteConfirmationModal({ 
  visible, 
  onCancel, 
  onConfirm, 
  title, 
  message, 
}) {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const { t } = useTranslation()
  const theme = useTheme()

  const handleDelete = async () => {
    try {
      setIsLoading(true)
      await onConfirm()
      setIsLoading(false)
      onCancel()
    } catch(error) {
      setIsLoading(false)
      console.log(error)
      setError(error.text || t('error'))
      Sentry.captureException(error)
    }
  }

  return (
    <Modal
      visible={visible}
      backdropStyle={styles.backdrop}
      onBackdropPress={onCancel}
      style={styles.modal}
    >
      <View style={[styles.content, { backgroundColor: theme['background-basic-color-1'] }]}>
        <Text category='h6' style={styles.title}>
          {title || t('deleteWarningTitle')}
        </Text>
        <Text style={styles.text}>
          {message || t('deleteWarningText')}
        </Text>
        {error && (
          <Text status='danger' style={styles.error}>
            {error}
          </Text>
        )}
        <View style={styles.buttons}>
          <Button
            status='basic'
            onPress={onCancel}
            style={styles.button}
            disabled={isLoading}
          >
            {t('cancel')}
          </Button>
          <Button
            status='danger'
            onPress={handleDelete}
            style={styles.button}
            disabled={isLoading}
          >
            {t('delete')}
          </Button>
        </View>
      </View>
    </Modal>
  )
}

const styles = StyleSheet.create({
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  modal: {
    width: '90%',
    maxWidth: 500,
    borderRadius: 4,
  },
  content: {
    padding: 20,
    borderRadius: 4,
  },
  title: {
    marginBottom: 10,
  },
  text: {
    marginBottom: 5,
  },
  buttons: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 20,
  },
  button: {
    marginLeft: 10,
  }
}) 